var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIdea = function SvgIdea(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 3a6.5 6.5 0 0 1 3.8 11.8c-.5.4-.8 1-.8 1.6v.1H9v-.1c0-.6-.3-1.2-.8-1.6A6.5 6.5 0 0 1 12 3zM9 18h6v.8a1 1 0 0 1-1 1h-.6a1.6 1.6 0 0 1-2.8 0H10a1 1 0 0 1-1-1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 .5a1 1 0 0 1 1 1V3a1 1 0 0 1-2 0V1.5a1 1 0 0 1 1-1zM1.8 11h1.6a1 1 0 1 1 0 2H1.8a1 1 0 1 1 0-2zM20.6 11h1.6a1 1 0 1 1 0 2h-1.6a1 1 0 1 1 0-2zM4.6 3.7l1.2 1.2a1 1 0 0 1-1.4 1.4L3.2 5.1a1 1 0 0 1 1.4-1.4zM19.4 3.7a1 1 0 0 1 0 1.4l-1.2 1.2a1 1 0 0 1-1.4-1.4L18 3.7a1 1 0 0 1 1.4 0z"
  })));
};
export default SvgIdea;